import AuthLayout from './AuthLayout';
import { Form, message } from 'antd';
import SubmitBtn from './SubmitBtn';
import { useLocation, useNavigate } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import { InputOTP } from 'antd-input-otp';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { useState } from 'react';
import useUserSignUp from '../../_hooks/useUserSignUp';
import { observer } from 'mobx-react-lite';

const VerifyEmail = observer(() => {
    return (
        <div>
            <AuthLayout
                isBack={
                    <div className="flex items-center gap-2 text-theme-icon-color mb-[10px] cursor-pointer">
                        <IoArrowBack className="text-xl text-theme-icon-color" />
                        <span className="font-favorit font-[500] text-[14px]">
                            Back
                        </span>
                    </div>
                }
                title="Email verification"
                subtitle="Verify your email"
                content={<VerifyEmailForm />}
            />
        </div>
    );
});
export default VerifyEmail;

const VerifyEmailForm = observer(() => {
    const [form] = Form.useForm();
    const [isTimerFinished, setIsTimerFinished] = useState(false);
    const { verifyCode, isLoading, resendVerificationCode } = useUserSignUp();

    const navigate = useNavigate();
    const { state } = useLocation();

    const onFinish = (values) => {
        const { otp } = values;
        if (!otp || otp.includes(undefined) || otp.includes(''))
            return form.setFields([
                {
                    name: 'otp',
                    errors: ['Please enter a valid OTP!'],
                },
            ]);
        const otpNumber = otp.join('');
        verifyCode(state.email, otpNumber)
            .then(() => {
                message.success('Verification Successfully');
                navigate('/auth/login');
            })
            .catch((error) => {
                message.error(error.message);
            });
    };

    const handleResendCode = () => {
        resendVerificationCode(state.email)
            .then(() => {
                message.success('Verification code sent to your email');
                setIsTimerFinished(false);
            })
            .catch((error) => {
                message.error(error.message);
            });
    };

    return (
        <>
            <div>
                <p className="text-[14px] font-medium text-[#5B5F5D] font-favorit mb-[4px]">
                    We have sent a verification code to your email address:{' '}
                    {state.email ? state.email : ''}
                </p>
                <span
                    className="font-favorit font-[500] text-[14px] text-theme-orange cursor-pointer hover:underline"
                    onClick={() => navigate('/auth/login')}>
                    Change Email ID
                </span>{' '}
            </div>
            <Form
                form={form}
                name="login"
                layout="vertical"
                onFinish={onFinish}
                requiredMark={false}
                autoComplete="off"
                className="auth-form-antd mt-[10px]">
                {/* OTP */}
                <div className="flex w-full justify-between ">
                    <Form.Item
                        name="otp"
                        className="mb-[16px] custom-otp-input"
                        rules={[{ validator: async () => Promise.resolve() }]}>
                        <InputOTP
                            autoFocus
                            inputType="numeric"
                            length={6}
                            placeholder="-"
                            className="otp-input"
                        />
                    </Form.Item>
                    <div className="flex  w-[78px] h-[40px] items-center">
                        {isTimerFinished ? (
                            <span
                                onClick={() => {
                                    handleResendCode();
                                }}
                                className=" text-[12px] font-favorit text-theme-orange cursor-pointer underline leading-[12px] ">
                                Resend Code
                            </span>
                        ) : (
                            <CountdownCircleTimer
                                isPlaying={!isTimerFinished}
                                duration={15}
                                colors={[['#F46147']]}
                                size={36}
                                strokeWidth={3}
                                onComplete={() => setIsTimerFinished(true)}>
                                {({ remainingTime }) => (
                                    <div className="text-[12px] text-[#8C8C8C] font-favorit">
                                        {remainingTime + 's'}
                                    </div>
                                )}
                            </CountdownCircleTimer>
                        )}
                    </div>
                </div>

                <Form.Item className="mb-[16px]">
                    <SubmitBtn
                        label="Verify & sign up"
                        className="w-full"
                        isLoading={isLoading}
                    />
                </Form.Item>
            </Form>
        </>
    );
});
